<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      selected-product="cso"
      :product-options="productOptions"
      show-date
      :filter-names="filterNames"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <!-- <template v-slot:actions="{ item }"> </template> -->

      <template #description>
        <v-row>
          <v-col cols="12">
            <utilization-cards
              :loading="isLoading"
              :items="aggregatedData?.utilization"
            />
          </v-col>
          <v-col cols="12">
            <network-health
              :loading="isLoading"
              :items="aggregatedData?.locations"
            />
          </v-col>
          <v-col cols="12">
            <div class="font-weight-bold">
              Utilization Breakdown
            </div>
          </v-col>
        </v-row>
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">

        </v-card>
      </template> -->
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <template #actionModals>
        <div />
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
    UtilizationCards: () => import("./utils/UtilizationCards.vue"),
    NetworkHealth: () => import("./utils/NetworkHealth.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      permissions: {
        view: "charge-stations.view",
        create: "charge-stations.create",
        edit: "charge-stations.edit",
        delete: "charge-stations.delete",
      },
      filters: {},
      subFilters: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "utilizations/getLoading",
      aggregatedData: "utilizations/getAggregatedData",
      meta: "utilizations/getMeta",
      list: "utilizations/getList",
    }),
    _headers() {
      const headers = [
        {
          text: "Charger ID",
          align: "left",
          sortable: false,
          value: "charger_id",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        {
          text: "Location",
          align: "left",
          sortable: false,
          value: "location_name",
        },

        {
          text: "Utilization By Time",
          align: "center",
          sortable: false,
          value: "utilization_wrt_time",
        },
        {
          text: "Utilization By Energy",
          align: "center",
          sortable: false,
          value: "utilization_wrt_energy",
        },
        {
          text: "Avg Utilization By Time",
          align: "center",
          sortable: false,
          value: "avg_utilization_wrt_time",
        },
        {
          text: "Avg Utilization By Energy",
          align: "center",
          sortable: false,
          value: "avg_utilization_wrt_energy",
        },
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["search", "locations", "charge_point"];
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {},
  beforeDestroy() {
    const params = {
      name: "data_completeness",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options };

      this.$store.dispatch("utilizations/AggregatedData", params);
      this.$store.dispatch("utilizations/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    },
  },
};
</script>
